import type { ProfileSummary } from '@rango-dev/internal-profile/api';
import type { ProfileWalletsModalProps } from '@rango-dev/internal-profile/components';

import { ProfileWalletsModal as MainProfileWalletsModal } from '@rango-dev/internal-profile/components';
import { useStackModal } from '@rango-dev/internal-profile/hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../../hooks/reduxHooks';
import { ModalHeader } from '../../ModalHeader';

type PropTypes = Pick<
  ProfileWalletsModalProps,
  'indexInStack' | 'showAddedAccounts' | 'setShouldOpenConnectWalletsModal'
>;

export function ProfileWalletsModal(props: PropTypes) {
  const navigate = useNavigate();
  const isUserLoggedIn = useAppSelector((state) => state.profile.isLoggedIn);
  const { data: profileSummary } = useAppSelector((state) => state.profile.profileSummary.private);
  const selectedAccount = useAppSelector((state) => state.profile.profileAuth.account);
  const { t } = useTranslation();
  const { clear } = useStackModal();
  const onLogin = (profileSummary: ProfileSummary) => {
    clear();
    navigate(`/profile/${profileSummary.username}`, { replace: true });
  };

  return (
    <MainProfileWalletsModal
      {...props}
      data={{ isUserLoggedIn, profileSummary, selectedAccount }}
      renderHeader={(headerProps) => (
        <ModalHeader
          showBackButton={headerProps.showBackButton}
          title={isUserLoggedIn ? t('Your Profile Wallets') : t('Login with wallet')}
          onClose={() => {
            headerProps.handleClose();
          }}
        />
      )}
      onLogin={onLogin}
    />
  );
}
